import React from "react";
import { createPortal } from "react-dom";
import { Eye, Pencil } from "lucide-react";
import styles from "../ResourcesPlanner.module.scss";

export default function AllocationActionMenu({ position, onQuickView, onEditAllocation, onClose, menuRef }) {
  return createPortal(
    <div
      ref={menuRef}
      className={styles.actionMenu}
      style={{
        position: "fixed",
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 1000,
      }}
    >
      <div className={styles.actionMenuItem} onClick={onQuickView}>
        <Eye size={14} />
        <span>Quick View</span>
      </div>
      <div className={styles.actionMenuItem} onClick={onEditAllocation}>
        <Pencil size={14} />
        <span>Edit Allocation</span>
      </div>
    </div>,
    document.body
  );
}
